import { useEffect, useState } from "react";

import { decoColumns } from "./deco-columns";
import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const usePeople = () => {
    const { platformId } = useParams();
    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });
    const [data, setData] = useState({ people: [], pagination: {} });
    const [queryParams, setQueryParams] = useState({});
    const { getSearchParams } = useSearchParams();

    const getAllPeople = async () => {
    // TODO : need to update this once backend consistent response changes will be done
        const { data, pagination } = await axiosInstance.get(`/people/${platformId}`, {
            params: {
                page : getSearchParams("page"),
                limit: getSearchParams("limit")
            }
        });
        setData({
            people: data,
            pagination
        });
    };

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getAllPeople();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    return {
        data,
        loading,
        columns: decoColumns(),
        setQueryParams,
        getAllPeople
    };
};

export default usePeople;
